import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import DropdownMenuComp from './DropdownMenu';
import classes from './Dropdown.module.scss';

export class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    if (!this.props.fixPosition) return;
    const parent = this.button.parentNode.getBoundingClientRect();
    const tip = {
      height: this.button.offsetHeight,
      width: this.button.offsetWidth
    };
    const tipPosition = {
      bottom: 'auto',
      left: 'auto',
      position: 'fixed',
      right: 'auto',
      top: 'auto',
      transform: 'none'
    };

    tipPosition.left = parent.left + (parent.width - tip.width) / 2;

    this.setState({
      // eslint-disable-line react/no-did-mount-set-state
      style: tipPosition
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isVisible && this.state.isVisible && this.props.onOpen) {
      this.props.onOpen();
    }
  }

  handleCloseDropdownMenu = (forceClose = false) => {
    if (!this.props.manualDropdown && (forceClose || (!this.props.persistentDropdown && this.state.isVisible))) {
      this.setState({
        isVisible: false
      });
    }
  };

  handleToggleDropdownMenu = (evt) => {
    if (evt) {
      evt.stopPropagation();
    }
    this.setState({
      isVisible: !this.state.isVisible
    });
  };

  render() {
    const {
      buttonClassName,
      buttonComponent,
      containerClassName,
      dataTestId,
      openButtonComponent,
      menuComponent,
      dropdownClassName,
      noCaret
    } = this.props;
    const buttonWhenOpen = openButtonComponent || buttonComponent;
    const renderedButton = this.state.isVisible ? buttonWhenOpen : buttonComponent;
    const containerClasses = _compact([classes.dropdownContainer, containerClassName]).join(' ');
    const testProps = dataTestId ? { 'data-testid': dataTestId } : {};

    return (
      <div className={containerClasses} style={this.state.style} {...testProps}>
        <div
          className={buttonClassName}
          onClick={this.handleToggleDropdownMenu}
          ref={(elt) => {
            this.button = elt;
          }}
        >
          {renderedButton}
        </div>
        {this.state.isVisible ? (
          <DropdownMenuComp
            buttonRef={this.button}
            dropdownClassName={dropdownClassName}
            handleCloseMenu={this.handleCloseDropdownMenu}
            isVisible={this.state.isVisible}
            menuNoLeft={this.props.menuNoLeft}
            menuNoTop={this.props.menuNoTop}
            menuComponent={menuComponent}
            noCaret={noCaret}
          />
        ) : null}
      </div>
    );
  }
}

Dropdown.propTypes = {
  buttonClassName: PT.string,
  buttonComponent: PT.element.isRequired,
  containerClassName: PT.string,
  dataTestId: PT.string,
  dropdownClassName: PT.string,
  menuComponent: PT.element.isRequired,
  menuNoLeft: PT.bool,
  menuNoTop: PT.bool,
  openButtonComponent: PT.element,
  persistentDropdown: PT.bool,
  manualDropdown: PT.bool,
  noCaret: PT.bool,
  fixPosition: PT.bool,
  onOpen: PT.func
};

export default Dropdown;
